import * as z from "zod";

export const CoverageFlatTeamSettingsSchema = z.object({
  "shopifyExtension/logo": z.string().nullish(),
  "shopifyExtension/displayIcon": z.boolean().nullish(),
  "shopifyExtension/icon": z.string().nullish(),
  "shopifyExtension/iconColor": z.string().nullish(),
  "shopifyExtension/iconBackgroundColor": z.string().nullish(),
  "shopifyExtension/redoProductImage": z.string().nullish(),
  "infoModal/sideImage": z.string().nullish(),
  "infoModal/logo": z.string().nullish(),
  "infoModal/headerText": z.string().nullish(),
  "infoModal/subheaderText": z.string().nullish(),
  "infoModal/cartIconEnabled": z.boolean().nullish(),
  "infoModal/checkoutIconEnabled": z.boolean().nullish(),
  "infoModal/customCss": z.string().nullish(),
  "infoModal/enableTopLayerModalApi": z.boolean().nullish(),

  // coverage.general_coverage (parent Coverage page — "Coverage" section)
  hideCheckbox: z.boolean().nullish(),
  "shopifyExtension/coverageExcludePickup": z.boolean().nullish(),

  // coverage.exclusions (parent Coverage page — "Exclusions" section)
  discountCodePartialMatch: z.boolean().nullish(),
  coverageExcludeTags: z.array(z.string()).nullish(),
  coverageExcludeSources: z.array(z.string()).nullish(),
  coverageExcludeCustomerTags: z.array(z.string()).nullish(),
  coverageExcludeProperties: z.array(z.string()).nullish(),
  "returns/coverageExcludedVariantMetafields": z.array(z.string()).nullish(),
  coverageExcludeDiscountCodes: z.array(z.string()).nullish(),

  // coverage.return_coverage (parent Coverage page — "Return coverage" section)
  coverage: z
    .object({
      storeCredit: z.boolean().nullish(),
      exchange: z.boolean().nullish(),
      refund: z.boolean().nullish(),
    })
    .nullish(),
  "returns/finalSaleReturns/enabled": z.boolean().nullish(),
  "publicapi/discountsAreFinalSales": z.boolean().nullish(),
  "publicapi/coverageExcludeLocalPickup": z.boolean().nullish(),
  "publicapi/couponedItemsDiscountThreshold": z.number().nullish(),
  coverageExcludeProductTags: z.array(z.string()).nullish(),
  coverageExcludeCollections: z.array(z.string()).nullish(),
  "returns/returnsCoverageExcludedSkus": z.array(z.string()).nullish(),
  coverageExcludeCentEnding: z.array(z.string()).nullish(),

  // coverage.checkout_ui_customizations (parent Coverage page — "Checkout UI customizations")
  "shopifyExtension/checkoutUICustomizations/titleTextSize": z
    .string()
    .nullish(),
  "shopifyExtension/checkoutUICustomizations/subtextSize": z.string().nullish(),
  "shopifyExtension/checkoutUICustomizations/spacing": z.string().nullish(),

  // coverage.display_options (parent Coverage page — "Display options" section)
  html: z.string().nullish(),
  checkboxFontSize: z.number().nullish(),
  checkboxSelector: z.string().nullish(),

  // coverage.pre_protected_orders (parent Coverage page — "Pre-protected orders")
  preProtectedOrdersEnabled: z.boolean().nullish(),

  // coverage.advanced_coverage (parent Coverage page — "Advanced" section)
  "shopifyExtension/variantNaming": z
    .enum(["alphanumeric", "custom", "default"])
    .nullish(),
  "shopifyExtension/deleteCartProperties": z.boolean().nullish(),

  // coverage.digital_warehouse (parent Coverage page — "Redo digital warehouse")
  "shopifyExtension/digitalWarehouse/enabled": z.boolean().nullish(),
});
